import { useEffect, useState } from 'react';
import { ClipboardList } from 'lucide-react';
import Modal from './Modal';
import Button from './elements/Button';

export default function JsonDetailsModal({ open, onClose, jsonText, children }) {
  const [copied, setCopied] = useState(false);
  const isOpen = typeof open === 'boolean' ? open : Boolean(jsonText);

  useEffect(() => {
    if (!isOpen) return;
  }, [isOpen]);

  const handleCopyToClipBoard = () => {
    if (!jsonText) return;
    navigator.clipboard.writeText(jsonText);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <>
      {isOpen && (
        <Modal open={isOpen} onClose={onClose} icon={<ClipboardList />} title="JSON Details" className="max-w-full">
          <div className="flex flex-col gap-2">
          <div className="text-right">
            <Button onClick={handleCopyToClipBoard} type="primary" size="small">
              {copied ? 'Copied!' : 'Copy to Clipboard'}
            </Button>
          </div>
          <pre className="overflow-x-auto text-xs max-h-[85vh]">
            {jsonText}
          </pre>
          {children}
          </div>
        </Modal>
      )}
    </>
  );
}
